import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, Image } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { ListReq, DeleteReq } from 'Store/manufactuer/types'
import { selectActionEvent, selectList, selectListEvent } from 'Store/manufactuer/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { manufactuerListAPI, deleteManufactuerAPI } from 'Store/manufactuer/api'
import { getManufacturersStatus } from 'helpers/format'
import { StatusTag } from 'Components/utilities'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import Detail from './detail'
import { ConfirmDailog, EventModal } from 'Components/modal'
import { appConfig } from 'config'
import { clearEventAction } from 'Store/manufactuer/actions'
import { ImageFallback, ManufacurerStatus, ManufacurerStatusText } from 'helpers/constanst'

type Props = {} & ReduxProps

const Manufactuer: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, dataList, event } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)

  const [filter, setFilter] = useState({
    keyword: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })

  const datas = dataList.data

  const onGetDataList = (): void => {
    const req: ListReq = {
      keyword: filter.keyword?.trim() || '',
      merchant_id: currentUser?.activeMerchant?.id || 0,
    }
    dispatch(manufactuerListAPI(req, currentUser.accessToken))
  }

  const onDeleteUom = (id: number): void => {
    const req: DeleteReq = {
      id,
    }
    dispatch(deleteManufactuerAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetDataList()
    }
  }, [pagination])

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDeleteUom(selectedID)
    onCloseConfirmDelete()
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetDataList()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetDataList()
  }

  const isCanEdit = (id: number) => {
    if (parseInt(appConfig.merchantID || '') === currentUser?.activeMerchant?.id) return true
    return (currentUser?.activeMerchant?.id || 0) === id
  }

  const renderStatus = (status: ManufacurerStatus) => (
    <StatusTag isPass={status === ManufacurerStatus.PUBLISH} text={getManufacturersStatus(status)} />
  )

  const renderImage = (img: string) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
  )

  const renderActionButton = (id: number, record: any) => {
    if (!isCanEdit(record.merchant_id)) return
    return (
      <Space size="middle">
        <ActionButton
          text=""
          icon={<EditOutlined />}
          label="แก้ไข"
          action="edit"
          onClick={() => onClickEdit(record.id)}
        />
        <ActionButton
          text=""
          icon={<DeleteOutlined />}
          label="ลบ"
          action="deleted"
          onClick={() => onClickDelete(record.id)}
        />
      </Space>
    )
  }

  const columns = [
    {
      title: 'รูปภาพโลโก้',
      dataIndex: 'logo',
      key: 'logo',
      render: renderImage,
      width: '120px',
    },
    {
      title: 'ชื่อผู้ผลิต',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      render: renderStatus,
      filters: [
        { text: ManufacurerStatusText.DRAFT, value: ManufacurerStatus.DRAFT },
        { text: ManufacurerStatusText.PUBLISH, value: ManufacurerStatus.PUBLISH },
        { text: ManufacurerStatusText.UNPUBLISH, value: ManufacurerStatus.UNPUBLISH },
      ],
      onFilter: (value: any, record: any) => record.status === value,
    },
    // {
    //   title: 'สร้างโดย',
    //   dataIndex: 'merchant_id',
    //   key: 'merchant_id',
    //   render: renderCreatedBy,
    //   filters: [
    //     { text: CreatedByText.SYSTEM, value: 'system' },
    //     { text: CreatedByText.MERCHANT, value: 'merchant' },
    //   ],
    //   onFilter: (value: any, record: any) =>
    //     value === 'merchant'
    //       ? record.merchant_id === currentUser?.activeMerchant?.id
    //       : record.merchant_id !== currentUser?.activeMerchant?.id,
    // },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const DetailDrawer = (
    <Detail
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={12}>
          <Space size="middle" align="end">
            <SearchInput
              placeholder="ค้นหาชื่อผู้ผลิต"
              prefix={<SearchOutlined />}
              allowClear
              value={filter.keyword}
              onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
            />
            <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onGetDataList} />
          </Space>
        </MyCol>
        <MyCol>
          <Space size="middle">
            <PrimaryButton text="เพิ่มผู้ผลิต" icon={<PlusOutlined />} onClick={onClickCreate} />
          </Space>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  return (
    <>
      <HomePageLayout selected="manufacturers" title="ผู้ผลิต" label="รายการผู้ผลิตที่เป็นพันธมิตรกับเรา">
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          scrollX={800}
          size="small"
        />
        {DetailDrawer}
        {ConfirmDeleteModal}
        {LoadingModal}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectList(state),
    listEvent: selectListEvent(state),
    event: selectActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`
const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 80px;
  height: 80px;
  object-fit: contain;
`

export default connect(mapStateToProps)(Manufactuer)
